import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumbs, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { Routes } from "routes";
import { ComponentWithChildren } from "../../../common/types";

interface Props {
  onParentClick?: () => void;
}

const Breadcrumb: ComponentWithChildren<Props> = ({ onParentClick, children }) => {
  const { t } = useTranslation();
  const history = useNavigate();
  const { pathname } = useLocation();

  let pathNames = pathname.split("/").filter(x => x);

  const breadcrumbNameMap: { [key: string]: string } = {
    [Routes.badges]: t("common:headTitles.badges"),
    [Routes.createBadge]: t("common:headTitles.createBadge"),
    [Routes.printSettings]: t("common:headTitles.printerSettings"),
    [Routes.devices]: t("common:headTitles.devices"),
    [Routes.globalSettings]: t("common:headTitles.globalSettings"),
    [Routes.company]: t("common:headTitles.badges")
  };

  if ((pathNames[0] === Routes.badges.replace("/", "") || pathNames[0] === Routes.company.replace("/", "")) && pathNames.length !== 1) {
    pathNames.pop();
  }

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <HomeIcon data-testid="home-icon" color="primary" fontSize="small" sx={{ mt: "3px", cursor: "pointer" }} onClick={() => history(Routes.homepage)} />
      {pathNames.map((_, index) => {
        const last = children ? index === pathNames.length : index === pathNames.length - 1;
        const to = `/${pathNames.slice(0, index + 1).join("/")}`;

        return last ? (
          <Typography key={to} color="text.primary" sx={{ fontSize: 14 }}>
            {breadcrumbNameMap[to]}
          </Typography>
        ) : (
          <Typography
            key={to}
            color="primary"
            sx={{ fontSize: 14, cursor: "pointer" }}
            data-testid="clickable-link"
            onClick={() => {
              onParentClick ? onParentClick() : history(to);
            }}
          >
            {breadcrumbNameMap[to]}
          </Typography>
        );
      })}
      {children}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
